import Controller from '@ember/controller'
import type ReStudentSummaryCourseProgressSpellingRoute from 'teacher-ui-client/reporting/ui-scope/re/student-summary/course-progress/spelling/route'
import { tracked } from '@glimmer/tracking'

export default class extends Controller<ModelFor<ReStudentSummaryCourseProgressSpellingRoute>> {
  queryParams = ['currentMapNumber']

  @tracked currentMapNumber = 1

  @tracked mapNumbersWithLessonsCompleted: Nullable<number[]> = null

  changeMap = (currentMapNumber: number) => {
    this.currentMapNumber = currentMapNumber
  }
}
